module.exports = __webpack_public_path__ + "img/education_title.802b834c.svg";